export const TopBarHeight = "50px";
export const LeftMenuWidth = "240px";